<template>
    <b-container>
      <b-row class="mt-5 mb-5">
          <b-col>
              <b-link :to="{name: 'org-dashboard'}"><i class="far fa-long-arrow-left mr-2"></i>Back to Conferences</b-link>
          </b-col>
      </b-row>

        <b-row class="mt-5 mb-5">
            <b-col>
                <b-form>
                    <b-form-group label="Conference Title" label-for="title">
                        <b-form-input id="title" v-model="newConference.title" required placeholder="Conference Title"></b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Submit</b-button>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "new-conference",
        data: function () {
            return {
                newConference: {
                    title: ''
                }
            }
        }
    }
</script>

<style scoped>

</style>
